<template>
    <div class="championship-stage">
        <div v-if="!games || games.length === 0" class="no-games">
            <div class="no-games-icon">🏐</div>
            <h3>Матчи не найдены</h3>
            <p>Для выбранного сезона матчи этого этапа еще не добавлены</p>
        </div>

        <championship-playoff v-else :playoff-games="[{ stage: stage, stage_name: stageName, games: games }]" />
    </div>
</template>

<script setup>
import ChampionshipPlayoff from '@/components/features/results/ChampionshipPlayoff.vue';

const props = defineProps({
    games: {
        type: Array,
        default: () => []
    },
    stage: {
        type: String,
        default: ''
    },
    stageName: {
        type: String,
        default: ''
    }
});
</script>

<style lang="scss" scoped>
.championship-stage {
    padding: 2rem 0;
}

.no-games {
    text-align: center;
    padding: 4rem 2rem;
    color: #64748b;

    .no-games-icon {
        font-size: 4rem;
        margin-bottom: 1rem;
    }

    h3 {
        font-size: 1.5rem;
        font-weight: 600;
        color: #1e293b;
        margin-bottom: 0.5rem;
    }

    p {
        font-size: 1rem;
        color: #64748b;
    }
}
</style>

